export enum ENetworkFlag {
  /** Vrai en mode Offline, Faux en mode Online*/
  isOffline = "isOffline",
  /** Vrai en mode Online et que la connexion est égale ou supérieure à 3g, sinon Faux */
  isOnlineReliable = "isOnlineReliable"
}